import { action } from 'typesafe-actions';
import { ResponseError } from '../../../services/api';
import { Config, Data, DataValues } from '../../../utils/newTableHelper';
import { Pagination, BudgetsDetailTypes } from './types';

export const loadRequest = (
  pagination?: Pagination,
  filter?: any,
  sorter?: any,
  budgetId?: number
) => action(BudgetsDetailTypes.LOAD_REQUEST, { pagination, filter, sorter, budgetId });
export const loadSuccess = (pagination: Pagination, data: Data[], config: Config) =>
  action(BudgetsDetailTypes.LOAD_SUCCESS, { pagination, data, config });
export const loadFailure = (error: ResponseError) =>
  action(BudgetsDetailTypes.LOAD_FAILURE, { error });

export const loadDetail = (budgetId?: number) =>
  action(BudgetsDetailTypes.DATA_REQUEST, { budgetId });
export const successDetail = (data: DataValues[], config: Config) =>
  action(BudgetsDetailTypes.DATA_SUCCESS, { data, config });
export const failureDetail = (error: ResponseError) =>
  action(BudgetsDetailTypes.DATA_FAILURE, { error });
